<adapt-dashboard-element name="Contacts">
    @if (editMode) {
        <div adapt-dashboard-title-buttons>
            <button adaptButton="editBorderless"
                    [adaptBlockingClick]="editContacts"
                    [disabled]="disabled"
                    data-tour="edit-contact-details-button"
                    data-test="edit-contact-details-button"></button>
        </div>
    }

    <ng-container *adaptLoadingUntilFirstEmit="let contactTypes of mappedContactTypes$">
        @for (contactType of contactTypes; track contactType) {
            <dl>
                @for (contact of contactType.contacts; track contact) {
                    <dd>
                        <adapt-contact-detail [detail]="contact"></adapt-contact-detail>
                    </dd>
                }
            </dl>
        }
    </ng-container>
</adapt-dashboard-element>
